<!--展示PDFDialog-->
<template>
	<el-dialog :visible.sync="pdfDialogVisible" center title="电子保单" width="80%" top="6vh">
		<el-row v-loading="isDownLoading">
			<el-col :span="8">
				<el-button :loading="isDownLoading" size="mini" type="primary" @click="onDownloadAll">下载全部</el-button>

				<div v-if="pdfDataList.length > 0">
					<el-row v-for="(itemData, index) in pdfDataList" :key="index" type="flex">
						<el-col>
							<el-row>
								<h3>{{ itemData.label }}</h3>
							</el-row>
							<el-row v-for="(item, indexNei) in itemData.value" :key="indexNei" align="middle" type="flex">
								<div class="u-m-r-10">
									<el-button
										class="u-m-l-5"
										type="text"
										@click="download(Object.assign(item, {fileType: itemData.label}))">
										<span class="u-font-weight-bold" :style="item.isDownload ? {color: 'red'} : {color: 'gray'}">
											{{ item.isDownload ? '已下载' : '未下载' }}
										</span>
									</el-button>
									<el-button type="text" @click="onCopy(item.endorseNo || item.policyNo)">复制单号</el-button>
								</div>

								<el-radio
									style="margin-top: 3px"
									v-model="file.url"
									:label="item.url"
									@click.native.prevent="handleViewPdf(item, itemData.label)">
									{{ item.endorseNo || item.policyNo }}
								</el-radio>
							</el-row>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col v-if="getFileType === 'pdf'" :span="16">
				<el-button-group>
					<el-button icon="el-icon-arrow-left" type="primary" @click="prevPdfPage">上一页</el-button>
					<el-button type="primary" @click="nextPdfPage">
						下一页
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
					<el-button type="primary" @click="download()">下载</el-button>
				</el-button-group>
				<div style="margin-top: 10px; color: #409eff">{{ pageNum }} / {{ pageTotalNum }}</div>
				<pdf :page="pageNum" :src="pdfSrc" @progress="loadedRatio = $event" @num-pages="pageTotalNum = $event"></pdf>
			</el-col>
			<el-col v-if="getFileType === 'image'" :span="16">
				<el-button-group>
					<el-button size="mini" type="primary" @click="download()">下载</el-button>
				</el-button-group>
				<br />
				<viewer ref="viewer" :images="[file.url]" class="viewer">
					<template #default="scope">
						<img v-for="(src, index) in scope.images" :key="index" :src="src" alt="" width="100%" />
						{{ scope.options }}
					</template>
				</viewer>
			</el-col>
		</el-row>
	</el-dialog>
</template>
<script>
import pdf from 'vue-pdf'
import 'viewerjs/dist/viewer.css'
import {component as Viewer} from 'v-viewer'
import {getDocs} from '@/api/insurance/policy'
import {downloadAndRenameFile, handleDownCategoryFile} from '@/util/util'
import {addUserLog} from '@/api/admin/log'
import {EnumLogType} from '@/const/enum'
import eventBusKey from '@/util/eventBus'
import {mixinsPolicyDownload} from '@/mixins/mixinsPolicyDownload'
import {getPolicyDetailLogKeys} from '@/util/userLog'

export default {
	name: 'showPdfDialog',
	components: {pdf, Viewer},
	mixins: [mixinsPolicyDownload],
	data() {
		return {
			isDownLoading: false,
			pdfDialogVisible: false,
			pdfDataList: [],
			rowSelected: {},
			policyList: [],
			endorseList: [],
			invoiceList: [],
			pageNum: 1,
			pageTotalNum: 1,
			loadedRatio: 0,
			file: {
				fileName: '',
				url: '',
				fileExt: '',
			},
			fileType: ['保单', '批单', '发票'],
		}
	},
	computed: {
		pdfSrc() {
			let {url = ''} = this.file
			return url
				? pdf.createLoadingTask({
						url,
						// 引入pdf.js字体，修复不显示
						cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
						cMapPacked: true,
					})
				: ''
		},
		getFileType() {
			let {fileExt = ''} = this.file
			return fileExt === 'pdf' ? 'pdf' : 'image'
		},
	},
	methods: {
		/**
		 * 请求数据
		 * @param row
		 * @param isFp 是否为发票
		 */
		handleViewSurrenderDocs(row, isFp = false) {
			this.isDownLoading = true
			this.rowSelected = row
			this.file.url = ''
			let {policyNo = '', endorseNo = ''} = this.rowSelected
			let query = {
				policyNo: policyNo,
				endorseNo: endorseNo,
			}
			this.pdfDataList = []
			getDocs(query)
				.then((response = {}) => {
					let {code = -1, data = {}} = response.data || {}
					if (code !== 0) {
						return
					}
					let {policyList = [], endorseList = [], invoiceList = []} = data || {}
					//处理数据
					if (policyList.length > 0) {
						this.pdfDataList.push({label: '保单', value: policyList})
						if (!endorseNo && !isFp) {
							this.file = policyList[0]
							this.file.fileType = '保单'
						}
					}
					let tempList = []
					if (endorseList.length > 0) {
						this.pdfDataList.push({label: '批单', value: endorseList})
						if (endorseNo && !isFp) {
							tempList = endorseList
						}
					}
					if (invoiceList.length > 0) {
						this.pdfDataList.push({label: '发票', value: invoiceList})
						if (isFp) {
							if (!endorseNo) {
								this.file = invoiceList[0]
								this.file.fileType = '发票'
							} else {
								tempList = invoiceList
							}
						}
					}
					//展示数据
					if (this.pdfDataList.length <= 0) {
						this.$alert('暂无数据，请10分钟后再试！', '提示').then(() => {})
						return
					}
					if (tempList.length > 0) {
						//查找当前显示
						let tempFile = tempList.find(({endorseNo: endorseNoNei}) => endorseNoNei === endorseNo)
						if (!tempFile) {
							tempFile = tempList[0]
						}
						this.file = tempFile
						this.file.fileType = !isFp ? '批单' : '发票'
					}
					//处理是否下载的数据
					this.onGetPolicyLogList()
					//展示
					this.pdfDialogVisible = true
				})
				.catch(() => {})
				.finally(() => {
					setTimeout(() => {
						this.isDownLoading = false
					}, 1000)
				})
		},
		showPdfDialog(type) {
			if (type === 1 && this.policyList.length > 0) {
				this.file = this.policyList[0]
				this.file.fileType = '保单'
			} else if (type === 1 && this.endorseList.length > 0) {
				this.file = this.endorseList[0]
				this.file.fileType = '批单'
			} else if (type === 2 && this.invoiceList.length > 0) {
				this.file = this.invoiceList[0]
				this.file.fileType = '发票'
			}
			this.pdfDialogVisible = true
		},
		handleViewPdf(file, label) {
			file.fileType = label
			this.file = file
		},
		// 上一页
		prevPdfPage() {
			let page = this.pageNum
			page = page > 1 ? page - 1 : this.pageTotalNum
			this.pageNum = page
		},
		// 下一页
		nextPdfPage() {
			let page = this.pageNum
			page = page < this.pageTotalNum ? page + 1 : 1
			this.pageNum = page
		},
		//  下载
		download(fileData = null) {
			console.log('this.file----', this.file)
			/**
			 * /download/{type}/{orderId}/{endorseNo}
			 * type- 1--全部下载
			 *   * 2--保单批单下载
			 *   * 3--发票下载
			 *   * 4--保单下载
			 *   * 5--批单下载
			 */
			if (!fileData) {
				fileData = this.file
			}
			let {fileType = '', endorseNo = '', policyNo = '', url = '', fileExt = ''} = fileData
			let {holder: {unitName = ''} = {}, unitName: unitName1 = '', title = ''} = this.rowSelected
			//直接下载
			downloadAndRenameFile(
				url,
				`${fileType}_${unitName || unitName1 || title}_${endorseNo ? endorseNo : policyNo}.${fileExt}`,
			)
				.then(() => {
					//下载成功后，需要更新下载状态
					this.onEventLog([`${fileType}_${endorseNo ? endorseNo : policyNo}`])
				})
				.catch((error) => {
					this.$alert(error.message || '下载失败，请稍后重试！', '提示').then(() => {})
				})
		},
		//  下载全部
		onDownloadAll() {
			let {policyNo = '', holder: {unitName = ''} = {}, unitName: unitName1 = '', orderId = ''} = this.rowSelected
			this.downloadCustom(`1/${orderId}`, `全部_${unitName || unitName1}_${policyNo}.zip`)
		},
		downloadCustom(urlType, fileName) {
			this.isDownLoading = true
			let path = `/dist/bowei/file?path=/export/download/${urlType}`
			handleDownCategoryFile(path, {}, fileName)
				.then(() => {
					this.$message.success('下载成功！')
					//下载成功后，需要更新下载状态
					let eventKeys = getPolicyDetailLogKeys(this.pdfDataList)
					this.onEventLog(eventKeys)
				})
				.catch(() => {
					this.$message.error('下载失败，请稍后重试！')
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},

		onEventLog(eventKeys = []) {
			//下载完成后记录
			addUserLog(EnumLogType.logPolicyPdfDownload, {
				eventKeys,
				eventStatus: '1',
			})
				.then(() => {
					// 记录成功
					this.$Bus.$emit(eventBusKey.BusPolicyPdfDownload, eventKeys)
				})
				.catch((error) => {})
		},

		onCopy(text) {
			this.$Clipboard({
				text,
			})
				.then(() => {
					this.$message.success('复制成功')
				})
				.catch(() => {
					this.$message.success('复制失败')
				})
		},
	},
	mounted() {},
	watch: {},
}
</script>

<style lang="scss" scoped></style>
